import Api from "./api.service";
import humps from "humps";

class Tenant {
  static getAll() {
    const payload = {
      params: {
        include: "vat"
      }
    };

    return Api.get("/api/v1/tenants", payload);
  }

  static store(tenantSlug) {
    window.localStorage.setItem("tenantSlug", tenantSlug);
  }

  static get() {
    return window.localStorage.getItem("tenantSlug");
  }

  static getCustomersReportLegacyEntity() {
    return window.localStorage.getItem("tenantCustomersReportLegacyEntity");
  }

  static purge() {
    window.localStorage.removeItem("tenantSlug");
  }

  static create(tenantAttributes, vatCountryCode) {
    const params = humps.decamelizeKeys(tenantAttributes);
    const payload = {
      data: {
        type: "tenants",
        attributes: params,
        relationships: {
          vat: {
            data: {
              type: "vats",
              id: vatCountryCode
            }
          }
        }
      }
    };

    return Api.post(`/api/v1/tenants/`, payload);
  }

  static update(tenantAttributes, vatCountryCode, tenantSlug) {
    const params = humps.decamelizeKeys(tenantAttributes);
    const payload = {
      data: {
        type: "tenants",
        id: tenantSlug,
        attributes: params,
        relationships: {
          vat: {
            data: {
              type: "vats",
              id: vatCountryCode
            }
          }
        }
      }
    };

    return Api.put(`/api/v1/tenants/${tenantSlug}`, payload);
  }

  static getCurrency() {
    return Api.get(`api/v1/site_settings`);
  }

  static getTenantsCurrency(tenantSlug) {
    return Api.get(`/api/v1/tenants/${tenantSlug}/tenant_currencies`);
  }

  static createTenantCurrencies(data, tenantSlug) {
    const payload = {
      data: {
        type: "tenant_currencies",
        attributes: { currency: data },
        relationships: {
          tenant: {
            data: {
              type: "tenants",
              id: tenantSlug
            }
          }
        }
      }
    };

    Api.post(`/api/v1/tenants/${tenantSlug}/tenant_currencies`, payload);
  }

  static updateTenantCurrenciesInvoice(data, tenantSlug) {
    const payload = {
      data: {
        type: "tenant_currencies",
        id: data.id,
        attributes: {
          invoice_minim_amount: data.invoiceMinimAmount
        },
        relationships: {
          tenant: {
            data: {
              type: "tenants",
              id: tenantSlug
            }
          }
        }
      }
    };
    Api.put(`/api/v1/tenants/${tenantSlug}/tenant_currencies/${data.id}`, payload);
  }

  static deleteTenantCurencies(id, tenantSlug) {
    return Api.delete(`/api/v1/tenants/${tenantSlug}/tenant_currencies/${id}`);
  }

  static exportCustomersReport(tenantSlug, exportCustomersReportFor, dateBetween, invoiceType) {
    const params = humps.decamelizeKeys({
      for: exportCustomersReportFor,
      dateBetween: dateBetween,
      invoiceType: invoiceType
    });
    const payload = {
      data: {
        type: "tenants",
        id: tenantSlug
      },
      params: params
    };
    return Api.get(`/api/v1/tenants/${tenantSlug}/export_customers_report`, payload);
  }
}

const TenantService = Object.freeze(Tenant);
export default TenantService;
